import { cn } from '@/lib/utils';
import * as React from 'react';

function Input({ className, type, style, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'border-[var(--border-color)] bg-[var(--background-color)] ring-offset-background flex h-10 w-full rounded-md border-2 px-3 py-2 text-sm',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        'placeholder:text-muted-foreground',
        'focus-visible-primary focus-visible:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'transition-colors duration-200',
        className,
      )}
      style={style}
      {...props}
    />
  );
}

export { Input };

